export enum ChampionshipEntity {
  CHAMPIONSHIP,
  CATEGORY,
  COUNTRY,
  EVALUATION,
  REQUEST,
}
